import { Maybe, SanityTextCta } from "@graphql-types";
import { BlocksContent, Link } from "@global";
import React from "react";
import { TextCtaWrapper } from "./textCta.style";

interface Props {
  data: Maybe<SanityTextCta> | undefined;
}

function TextCta({ data }: Props) {
  if (data == null) return null;
  const { content, enableBackgroundDesign, paddingTopBottom, link, label } = data;

  if (content == null) return null;

  return (
    <>
      <TextCtaWrapper
        size="default"
        contentLength={content.length}
        className={paddingTopBottom ? `ptb-${paddingTopBottom}` : `ptb-none`}
        enableBackgroundDesign={enableBackgroundDesign ?? false}
        link={link}
      >
        {link && (
          <Link
            className="privacy-page-logo"
            externalLink={link?.externalLink}
            internalLink={link?.internalLink}
          >
            {link?.imageURL && <img src={link?.imageURL} alt={`${label} by PRIVO`} />}
            {link?.linkText && link?.linkText}
          </Link>
        )}

        {content.map(contentData => (
          <div className="column" key={contentData?._key}>
            <BlocksContent data={contentData} />
          </div>
        ))}
      </TextCtaWrapper>
    </>
  );
}

export default TextCta;
